import { Controller } from '@hotwired/stimulus';

// Suggests a family trail name ("Mia’s Kōwhai Gully Loop") from the nickname until the grown-up edits the name.
export default class TrailNameController extends Controller<HTMLElement> {
  public static readonly targets = ['nickname', 'name'];

  public static readonly values = { trail: String };

  declare public readonly nicknameTarget: HTMLInputElement;
  declare public readonly nameTarget: HTMLInputElement;

  declare private readonly trailValue: string;

  private edited = false;

  public connect(): void {
    this.edited =
      this.nameTarget.value !== '' &&
      this.nameTarget.value !== this._suggestion();
  }

  public suggest(): void {
    if (!this.edited) {
      this.nameTarget.value = this._suggestion();
    }
  }

  public edit(): void {
    this.edited = this.nameTarget.value !== this._suggestion();
  }

  private _suggestion(): string {
    const nickname = this.nicknameTarget.value.trim().replace(/\s+/gu, ' ');

    return nickname === ''
      ? this.trailValue
      : `${nickname}’s ${this.trailValue}`;
  }
}
